<template>
    <div class="container">
        <div>
            <el-button type="primary" size="mini" @click="onSave">保存</el-button>
            <div class="fileWrap">
                <el-button type="warning" size="mini">上传</el-button>
                <input ref="inputRef" type="file" @change="upload">
            </div>
            <el-button size="mini" @click="back">返回</el-button>
        </div>
        <div class="tableWrap">
            <table>
                <thead>
                    <tr><td colspan="6">{{ invoiceData.title || '' }}</td></tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="6" align="left">
                            <div class="td-item">{{`缴款码：${invoiceData.paymentCode || ''}`}}</div>
                            <div class="td-item">
                                <span> {{`执收单位编码：${invoiceData.receivingCode || ''}`}}</span>
                                <span> {{`票据代码：${invoiceData.invoiceCode || ''}`}}</span>
                                <span> {{`校验码：${invoiceData.checkCode || ''}`}}</span>
                            </div>
                            <div class="td-item">
                                <span> {{`执收单位名称：${invoiceData.receivingName || ''}`}}</span>
                                <span> {{`票据号码：${invoiceData.invoiceNumber || ''}`}}</span>
                                <span> {{`填制日期：${invoiceData.billingDate || ''}`}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr><td rowspan="3">付款人</td><td>全称</td><td>{{invoiceData.payerName || ''}}</td><td rowspan="3">收款人</td><td>全称</td><td>{{invoiceData.payeeName || ''}}</td></tr>
                    <tr><td>账号</td><td>{{invoiceData.payerNumber || ''}}</td><td>账号</td><td>{{invoiceData.payeeNumber || ''}}</td></tr>
                    <tr><td>开户银行</td><td>{{invoiceData.payerBank || ''}}</td><td>开户银行</td><td>{{invoiceData.payeeBank || ''}}</td></tr>
                    <tr>
                        <td colspan="4">
                            <div class="td-item" style="justify-content: left;">
                                <span style="margin-right: 50px"> {{`币种：${invoiceData.currencyCode || '人民币'}`}}</span>
                                <span> {{`金额（大写）：${invoiceData.amountTaxCN || ''}`}}</span>
                            </div>
                        </td>
                        <td colspan="2">{{`（小写）：${invoiceData.amountTax || ''}`}}</td>
                    </tr>
                    <tr><td>项目编码</td><td>收入项目名称</td><td>单位</td><td>数量</td><td>收缴标准</td><td>金额</td></tr>
                    <tr v-for="el in invoiceData.invoiceLists" :key="el.commodityNo"><td>{{el.commodityNo || ''}}</td><td>{{el.commodityName || ''}}</td><td>{{el.unit || '元'}}</td><td>{{el.quantity || ''}}</td><td>{{el.standard || ''}}</td><td>{{el.amount || ''}}</td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td colspan="3">
                        <div class="td-item">
                            <span> {{`执收单位盖章：${''}`}}</span>
                            <span> {{`经办人盖章：${invoiceData.sealMark || ''}`}}</span>
                        </div>
                    </td><td colspan="3" style="text-align: left;">{{ `备注：${invoiceData.remarks || ''}` }}</td></tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import { getBaiduNormal, getNetocr, savePayment } from "@/api/common";
import { obsConfig, xiangyunKey } from "@/utils/secret.js";
import { numToCny } from "@/utils/utils.js";

  export default {
    name: 'InvoiceDecoder',
    components: {},
    data() {
        return {
            invoiceData: {},
            filePath: ''
        };
    },
    computed: {},
    mounted() {},
    methods: {
        netocr(file) {
            let formData = new FormData();
            formData.append("file", file);
            formData.append("key", xiangyunKey.key);
            formData.append("secret", xiangyunKey.secret);
            formData.append("typeId", 20090);
            formData.append("format", 'json');
            getNetocr(formData).then(res => {
                const { data } = res;
                this.invoiceData = data[0]?.invoice;
            }).catch(err => {
                console.log("🚀 ~ getNetocr ~ err:", err)
            })
        },
        baiduNormal(base64) {
            const params = {
                // image: base64,
                pdf_file: base64,
                verify_parameter: false,
                probability: false,
                location: false
            }
            getBaiduNormal(params).then(res => {
                console.log("🚀 ~ main ~ res:", res)
            
            }).catch(err => {
                console.log("🚀 ~ main ~ err:", err)
                
            })
        },
        obsFile(file) {
            const domainId = localStorage.getItem("domainId") || "default";
            const now = new Date();
            const y = now.getFullYear();
            const m = now.getMonth()+1<10?'0'+(now.getMonth()+1):now.getMonth()+1;
            const d = now.getDate()<10?'0'+now.getDate():now.getDate();
            const md = m+'-'+d;
			const objectKey=`uploads/${y}/${md}/${domainId}/${now.getTime()}/${file.name}`;
            let _this = this;
			
			// eslint-disable-next-line no-undef
			const obs = new ObsClient({
				access_key_id: obsConfig.ak,
				secret_access_key: obsConfig.sk,
				server : obsConfig.urlserver,
				timeout : 60 * 5,
			});
			obs.putObject({
				Bucket: obsConfig.BucketName,
				Key : objectKey,
				SourceFile: file //获取file文件
			}).then(function(result) {
				if(result.CommonMsg.Status < 300){
                    const httpurl = `https://${obsConfig.BucketName}.${obsConfig.urlserver}/${objectKey}`;
                    _this.filePath = httpurl;
                }
            });
        },
        upload(event) {
            // 获取当前选中的文件
            const File = event.target.files[0];
            this.obsFile(File);
            this.netocr(File);
            this.$refs.inputRef.value = ''
        },
        onSave() {
            if(!this.invoiceData.title) {
                return this.$message.error('请先上传文件');
            }
            const { paymentCode, receivingCode, invoiceCode, checkCode, receivingName, invoiceNumber, billingDate, 
                payerName, payerBank, payerNumber, payeeName, payeeNumber, payeeBank, amountTaxCN, amountTax, invoiceLists, sealMark, remarks
            } = this.invoiceData;
            const params = {
                payment_code: paymentCode,
                collection_unit_code: receivingCode,
                bill_code: invoiceCode,
                verification_code: checkCode,
                collection_unit_name: receivingName,
                bill_number: invoiceNumber,
                fill_date: billingDate,
                payer_name: payerName,
                payer_bank: payerBank,
                payer_account: payerNumber,
                payee_name: payeeName,
                payee_account: payeeNumber,
                payee_bank: payeeBank,
                amount_words: amountTaxCN || numToCny(amountTax),
                amount_figures: amountTax,
                project_code: invoiceLists[0]?.commodityNo,
                project_name: invoiceLists[0]?.commodityName,
                number: invoiceLists[0]?.quantity,
                fee_standards: invoiceLists[0]?.standard,
                sum_price: invoiceLists[0]?.amount,
                collection_unit: '',
                operator_name: sealMark,
                remark: remarks,
                file: this.filePath,
            };
            savePayment(params).then(res => {
                if(res.code == 1){
                    this.$message.success(res.msg);
                    setTimeout(()=>{
                        window.open('about:blank','_self').close();
                    }, 3000);
                }else{
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                console.log("🚀 ~ savePayment ~ err:", err)
            })
        },
        back() {
            // // 调用全局挂载的方法，关闭当前页
            // this.$store.dispatch("tagsView/delView", this.$route);
            // // 返回上一步路由
            // this.$router.go(-1);
            window.open('about:blank','_self').close();
        }
    }
}
</script>
  
<style lang="scss" scoped>
.container {
    padding: 24px;
    .fileWrap {
        position: relative;
        display: inline-block;
        margin: 0 16px;
    }
    .fileWrap input {
        position: absolute;
        right: 0;
        left: 0;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
    .tableWrap {
        margin-top: 24px;
        table {
            border-collapse: collapse;
            margin: auto;
            td {
                padding: 12px;
                border: 1px solid #000;
                .td-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 4px 0;
                    span {
                        display: block;
                    }
                }
            }
        }
    }
}
</style>
  